import React from "react";
import { Workflow } from "us.collection/components";

const Cnt_Workflow = () => {
  return <Workflow />;
};

export default Cnt_Workflow;
